// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as CrmControlledReleaseRepo from "./CrmControlledReleaseRepo.bs.js";
import * as DummyCrmControlledReleaseRepo from "./DummyCrmControlledReleaseRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyCrmControlledReleaseRepo.BetaUserRepo;
  } else {
    return CrmControlledReleaseRepo.BetaUserRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
